<template>
<GeneralContainer>
	<RequestSigninModal @close="closedModal=true" :canClose="false" ref="signinModal"></RequestSigninModal>
    <nav v-if="this.user.kolkinid" class="nav-tabs">
        <ul>
            <li>
                <router-link :to="{name:'licenses'}" active-class="active">
                    Licenses
                </router-link>
            </li>
            <li>
                <router-link :to="{name:'invoices'}" active-class="active">
                    Invoices
                </router-link>
            </li>

        </ul>
    </nav>

    <router-view v-if="this.user.kolkinid"></router-view>

    <div v-if="closedModal&&!this.user.kolkinid">
    	<h2>Sign in with the link sent to your email</h2>

    	<button @click="generateClick">
			Generate New Link
		</button>
    </div>
    <!-- <div v-else class="email-signin">
    	<h1>Sign in with email</h1>
  		<p>Enter the email address associated with your account, and we’ll send a magic link to your inbox.</p>

		<label>Your Email</label>
        <input @keydown.enter="linkConfirm" v-model="email">
		<span v-if="error">Email was not recognized</span>

		<button @click="linkConfirm" class="submit-button">
			Continue
		</button>

		<a @click="goBack"><i class="icon icon-chevron-left"></i> Back</a>
    </div> -->

</GeneralContainer>
</template>

<script>
import GeneralContainer from "@/components/base/GeneralContainer";
import RequestSigninModal from "@/components/base/RequestSigninModal";

import {
	mapGetters
} from 'vuex';
import store from "@/store"

export default {

    name: "LicensesInvoices",

    beforeRouteEnter(to, from, next){
		store.dispatch("checkSession").then(function () {
			next();
		}).catch(function(){
			next();
		})
    },

    components: {
        GeneralContainer,
        RequestSigninModal
    },

    data(){
    	return {
     		closedModal: false,
     	}
    },

	mounted(){
		if(!this.user.kolkinid){
			this.$refs.signinModal.open();
		}
	},

    methods:{
    	generateClick(){
     		this.$refs.signinModal.open();
     	},
    	goBack(){
			window.location = "/";
     	},
    },

    computed: {
    	...mapGetters(["user"])
    }

}
</script>

<style lang="less" scoped>
@import (reference) "@/assets/less/style.less";


.nav-tabs {

	.nav-horizontal;
	margin-bottom: 2em;

    // ul {
    //     list-style-type: none;
    //     display: flex;
    //     padding: 0;

    //     li {
    //         margin-right: 1em;
	// 		a {
	// 			color:var(--color-black);
	// 			&:hover {
	// 				text-decoration:none;
	// 			}
	// 		}
	// 		.active {
	// 			border-bottom:1px solid var(--color-black);
	// 		}
    //     }
    // }
}

.email-signin {

	border: 1px solid var(--color-gray-1);
	text-align: center;
	padding: 2em 1em 2em 1em;
	display: flex;
	flex-direction: column;
	align-items: center;
	max-width: 80%;
	margin-left: 10%;

	h1 {
		font-weight: 400;
		margin-bottom:0.5em;
	}

	p {
		margin-bottom: 2em;
	}

	a {
		cursor: pointer;
		&:hover {
			text-decoration: underline;
		}
	}

	input {
		border:none;
		background-color: var(--color-gray-2);
		margin-bottom:0;
	}

	button {
		width:85%;
		background-color: var(--color-blue-8);
		color: var(--color-white);
		display: block;
		border-radius: var(--radius-3);
		margin: 2em 0 1em 0;
	}

	@media @breakpoint-xl-up {
		padding: 2em 5em 2em 5em;
	}

}
</style>
